import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Popover, Tooltip } from "@mui/material";
import { ColDef, ColumnApi, GridApi, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import _, { set } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { LoadOrganizations, LoadPhoneNumberGroups, LoadPhoneNumbersGridData, LoadUsers, getRoles } from "../../actions/index";
import { setHeaderTitle, setRefreshHandler, setHeaderCount, setSelectedCount } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { AddUserIcon, CancelIcon, DownloadedIcon, EditIcon, LockIcon, MultiSelectCrossIcon, MultiSelectDeleteIcon, MultiSelectLockIcon, MultiSelectUnlockIcon, ReInviteIcon, TrashIcon } from "../../icon";
import { mapToUser } from "../../models/conversations";
import { OrganizationModel } from "../../models/organization.model";
import { PhoneNumbergroup, PhoneNumberModel } from "../../models/phone-number.model";
import { ProfileModel } from "../../models/profile.model";
import { Role, RoleModel } from "../../models/roles.model";
import { UserModel, UserStatus } from '../../models/users.model';
import { updateOrganizationsUsers, updateUsersSelectedOrgIDs } from "../../reducers/reducer";
import * as selector from '../../selectors/selectors';
import { UserService } from "../../services/UserService";
import { LocalStorage, UtilityService } from "../../services/UtilityService";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, GridStatusLabelVariant, ToasterTexts, UsersMassAction, appNote, buttonLabels, emptyLabels, pageTitles } from "../shared/constants";
import FilterComponent from "../shared/filters/filter.component";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import GridComponent from "../shared/grid";
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { ActionsRenderer } from "../shared/grid/actionsRenderer";
import { AvatarRenderer } from "../shared/grid/avatarRenderer";
import { HeaderTemplate, dateComparator } from "../shared/grid/grid.services";
import { StatusRenderer } from "../shared/grid/statusRenderer";
import PageHeaderComponent from "../shared/page-header.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import UserView from "./user-view.component";
import moment from "moment";
import { exportToExcel } from "../../helpers/ExportToExcel";
import ButtonComponent from "../shared/button/button.component";
import { SettingsModel } from "../../models/settings-model";
import { SettingsService } from "../../services/SettingsService";

interface Props {
}

const UserComponent = (props: Props) => {
	const dispatch = useDispatch();

	const Organizations: OrganizationModel[] = useSelector(selector.organizations)
	const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
	const phoneNumberGroups: PhoneNumbergroup[] = useSelector(selector.phonenumbergroups);
	const OrganizationPhoneNumberGroups = useSelector(selector.OrganzationPhoneNumberGroups);
	const Settings: SettingsModel = useSelector(selector.settingsObj)


	const SelectedOrganizations: string[] = useSelector(selector.SelectedUsersOrganizations)
	const organizationUsers: UserModel[] = useSelector(selector.OrganizationsUsers)
	const organizationPhonenumbers: PhoneNumberModel[] = useSelector(selector.OrganizationsphoneNumbers)
	const Users: UserModel[] = useSelector(selector.users)
	const Roles: RoleModel[] = useSelector(selector.roles)
	const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage()
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)

	const [buttonName, setButtonName] = useState<string>("")
	const [show, setShow] = useState<boolean>(false)
	const [editoption, setEditOption] = useState<boolean>(false)
	const [reinviteOption, setReinviteOption] = useState<boolean>(false)
	const [clickRowId, setClickRowId] = useState<string>("")
	const [text, setText] = useState<string>("")
	const [userToEdit, setUserToEdit] = useState<UserModel>(undefined)
	const [MobileMenu, setMobileMenu] = useState<boolean>(false)
	const [ShowFilters, setShowFilters] = useState<boolean>(false)
	const [IsLoading, setIsLoading] = useState<boolean>(false)
	const [anchorEl, setAnchorEl] = useState<Element | null>(null)
	const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false)
	const [CheckedUsers, setCheckedUsers] = useState<UserModel[]>([])
	const [openMassAction, setOpenMassAction] = useState<boolean>(false)
	const [gridApi, setGridApi] = useState<GridApi>()
	const [columnApi, setColumnApi] = useState<ColumnApi>(null)
	const [ShowMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false)
	const [ClickRowData, setClickRowData] = useState<UserModel | null>(null)
	const [rowData, setRowData] = useState<UserModel[]>([]);
	const [searchValue, setSearchValue] = useState<any>("");
	const [selectedOrgIds, setSelectedOrgIds] = useState<string[]>([]);
	const [gridLoading, setGridLoading] = useState<boolean>(false);
	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
	const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
	const [showMassReInviteConfirmDialog, setShowMassReInviteConfirmDialog] = useState<boolean>(false)
	const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState<boolean>(false)
	const [isclearPhoneNumberData, setIsClearPhoneNumberData] = useState<boolean>(false)
	const location = useLocation();

	const getorganizationPhoneNumber = (id: string) => {
		let data = organizationPhonenumbers.find(x => x.ID === id)?.PhoneNumber
		return UtilityService.maskPhoneNumberOnLength(data);
	}

	const getPhoneNumber = (id: string) => {
		let data = PhoneNumbers.find(x => x.ID === id)?.PhoneNumber
		return UtilityService.maskPhoneNumberOnLength(data);
	}

	const UsersColoumnDefs: ColDef[] = [
		{
			field: "FirstName",
			headerName: "Name",
			valueGetter: (params: ValueGetterParams) => {
				const firstName = IsMobileDevice ? UtilityService.trimMessage(params.data.FirstName, params.column.getActualWidth() < 100 ? params.column.getActualWidth() < 60 ? 2 : 4 : 8) : params.data.FirstName;
				const lastName = IsMobileDevice ? UtilityService.trimMessage(params.data.LastName, params.column.getActualWidth() < 100 ? params.column.getActualWidth() < 60 ? 2 : 4 : 8) : params.data.LastName;
				return UtilityService.replaceSpacesWithNBSP(`${firstName} ${lastName}`);
			},
			valueFormatter: (params: ValueFormatterParams) => {
				const firstName = IsMobileDevice ? UtilityService.trimMessage(params.data.FirstName, params.column.getActualWidth() < 100 ? params.column.getActualWidth() < 60 ? 2 : 4 : 8) : params.data.FirstName;
				const lastName = IsMobileDevice ? UtilityService.trimMessage(params.data.LastName, params.column.getActualWidth() < 100 ? params.column.getActualWidth() < 60 ? 2 : 4 : 8) : params.data.LastName;
				return UtilityService.replaceSpacesWithNBSP(`${firstName} ${lastName}`);
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				let number = PhoneNumbers.find(x => x.ID === params.data.PhoneNumberID)?.PhoneNumber
				const AvatarComponent = {
					component: AvatarRenderer,
					params: {
						SetName: params.data.FirstName + " " + params.data.LastName,
						ShowBadgeIcon: false,
						HideAvatar: IsMobileDevice,
						PhoneNumber: number,
					}
				}
				if (params.data) {
					return AvatarComponent
				}
				return undefined
			},
			headerCheckboxSelection: IsMobileDevice ? false : true,
			checkboxSelection: IsMobileDevice ? false : true,
			wrapText: IsMobileDevice ? true : false,
			autoHeight: IsMobileDevice ? true : false,
			resizable: true,
			cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "5px" } : { display: "flex" },
			minWidth: IsMobileDevice ? null : 200,
		},
		{
			field: "Email",
			headerName: "Email",
			cellRenderer: params => <a
				style={{ cursor: "pointer" }}
				href={`mailto: ${params.data.Email}`}
				className={"color-grid-link"}
				target="_blank" rel="noopener noreferrer"
			>
				{params.data.Email}
			</a>,
			hide: IsMobileDevice,
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			minWidth: 200,
		},
		{
			field: "OrganizationID",
			headerName: "Organization",
			valueGetter: (params: ValueGetterParams) => {
				return getOrgName(params.data.OrganizationID)
			},
			hide: !UserService.hasSysAdminRole()
		},
		{
			field: "PhoneNumber",
			headerName: "Phone Number",
			valueFormatter: (params) => {
				return UtilityService.unmaskPhoneNumberWithPlus(params.data.PhoneNumber)
			},
			valueGetter: (params: ValueGetterParams) => {
				const raw = UtilityService.unmaskPhoneNumberWithPlus(params.data.PhoneNumber) || "";
				return ` ${raw} ${raw.replace(/\D/g, "")} `;
			},
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? null : 150,
			width: IsMobileDevice ? null : 150,
			maxWidth: IsMobileDevice ? null : 150,
			hide: !UserService.hasSysAdminRole()
		},
		{
			field: "PhoneNumberID",
			headerName: "Phone Number",
			valueFormatter: (params) => {
				return getPhoneNumber(params.data.PhoneNumberID)
			},
			valueGetter: (params: ValueGetterParams) => {
				const raw = getPhoneNumber(params.data.PhoneNumberID) || "";
				return ` ${raw}  ${raw.replace(/\D/g, "")} `;
			},
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? null : 150,
			width: IsMobileDevice ? null : 150,
			maxWidth: IsMobileDevice ? null : 150,
			hide: UserService.hasSysAdminRole()
		},
		{
			field: "PhoneNumberGroups",
			headerName: "Line Group",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.RoleID === Role.MANAGER ? params.data.PhoneNumberGroups.map(x => x.GroupName).join(",") : params.data.PhoneNumberGroups ? params.data.PhoneNumberGroups[0]?.GroupName : "---";
			},
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? null : 150,
			width: IsMobileDevice ? null : 150,
			maxWidth: IsMobileDevice ? null : 150,
		},
		{
			field: "RoleID",
			headerName: "Role",
			headerComponentParams: {
				template: selectedFilterTypes.includes("Role") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			valueGetter: (params: ValueGetterParams) => {
				return getRoleName(params.data.RoleID)
			},
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? null : 150,
			width: IsMobileDevice ? null : 150,
			maxWidth: IsMobileDevice ? null : 150,
		},
		{
			field: "SecondaryPhoneNumbers",
			headerName: "Secondary Phone Numbers",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.RoleID !== Role.ORGANIZATION_ADMIN ? params.data?.SecondaryPhoneNumbers.map(x => x.phoneNumber).join(", ") : "---";
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? null : 150,
			hide: IsMobileDevice
		},
		{
			field: "IsDeleted",
			headerName: "Status",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.LastLoggedIn === null ? "Pending" : params.data.IsDeleted ? "Locked" : "Active";
			},
			headerComponentParams: {
				template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				if (params.data) {
					const label = params.data.LastLoggedIn === null ? "Pending" : params.data.IsDeleted ? "Locked" : "Active";
					const variant = params.data.LastLoggedIn === null ? GridStatusLabelVariant.Warning : params.data.IsDeleted ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Active;
					const Status = {
						component: StatusRenderer,
						params: {
							Variant: variant, Label: label, Id: params.data.ID
						}
					}
					return Status
				}
				return undefined
			},
			suppressSizeToFit: true,
			minWidth: 100,
			width: 100,
			maxWidth: 100,
		},
		{
			field: "CreatedDateTime",
			headerName: "Updated Date",
			valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.CreatedDateTime).toString(),
			sort: !IsMobileDevice ? 'desc' : null,
			hide: IsMobileDevice,
			comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
			minWidth: 150,
			width: 150,
			maxWidth: 150,
			suppressSizeToFit: true
		},
		{
			field: "Action",
			maxWidth: 40,
			headerName: "",
			pinned: "right",
			lockPinned: true,
			lockPosition: "right",
			cellClass: "ag-cell-actions-style",
			headerClass: "bg-color-secondary",
			cellRenderer: params => <ActionsRenderer MenuData={getMenuActions(params.data)}
				{...params}
			/>,
			resizable: false,
			sortable: false,
			hide: IsMobileDevice
		},
	]

	useEffect(() => {
		if (UserService.getLoggedInUserRole() === Role.MANAGER) {
			const secondaryPhonenumbers = LocalStorage.get("current-user")?.secondaryPhoneNumbers.map(x => x.phoneNumberId)
			const allPhoneNumbers = [UserService.getUserPhoneNumberId(), ...(secondaryPhonenumbers || [])];
			const usersingroups = Users.filter(x => allPhoneNumbers.includes(x.PhoneNumberID))

			setRowData(usersingroups);
			setHeaderCount(usersingroups?.length || 0)
		}
		else {
			setRowData(Users)
			setHeaderCount(Users?.length || 0)
		}
	}, [Users])

	useEffect(() => {
		if (UserService.hasSysAdminRole()) {
			setSelectedOrgIds(SelectedOrganizations);
			setRowData(organizationUsers)
		}

		const state = location.state as any;
		const PhoneNumberID = state?.PhoneNumberID;
		const orgid = state?.selectedOrgId;
		const number = UtilityService.unmaskPhoneNumber(getorganizationPhoneNumber(PhoneNumberID));
		if ((!!gridApi && !!number) || (!!gridApi && !!orgid)) {

			gridApi.setQuickFilter(number);
			setSearchValue(number);
			setSelectedOrgIds([orgid])
		}
		const OrganizationID = state?.OrganizationID
		const organizationName = getOrgName(OrganizationID)
		if (!!gridApi && !!organizationName) {
			setSelectedOrgIds([OrganizationID])
			setRowData([])
			//gridApi.setQuickFilter(organizationName)
		}

	}, [gridApi])

	const searchUsers = (e: any) => {
		setSearchValue(e.target.value)
		gridApi.setQuickFilter(e.target.value)
	}

	useEffect(() => {

		if (UserService.hasOrgAdminRole() || UserService.hasManagerRole()) {
			LoadUsers(dispatch);
			LoadPhoneNumbersGridData(dispatch);
			LoadPhoneNumberGroups(dispatch, UserService.getCurrentUserOrgId())
		}
		if (Roles?.length === 0) {
			getRoles(dispatch)
		}
		if (UserService.hasSysAdminRole) {
			LoadOrganizations(dispatch);
		}

		if (!Profile.ID)
			UserService.getCurrentUser()
		// LoadProfile(dispatch);
		return () => {
			setSelectedCount(0)
		}
	}, [])



	const getUsersByOrgId = (ids) => {

		if (rowData.length === 0 && !!gridApi) {
			gridApi.showLoadingOverlay();
		}

		UserService.getUsersByOrganizations(ids).then((res) => {
			if (res.status === 200) {
				let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				const users = res.data.map(mapToUser).filter(user => regex.test(user.Email.toLowerCase()));
				setGridLoading(false);
				setRowData(users);
				setHeaderCount(users?.length || 0)
				dispatch(updateOrganizationsUsers(users))
				dispatch(updateUsersSelectedOrgIDs(ids))
			}
		}).catch(err => {
			setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
		})

	}

	const initialFilterOptions = () => {
		const filterData: CustomFilterCategory[] = [
			{
				Id: 1,
				Title: "Status",
				IsSelectedAll: false,
				Options: _(!UserService.hasSysAdminRole() ? Users : organizationUsers)
					.map((row) => ({
						Key: "UserStatus",
						Id: row.ID,
						Label: row.LastLoggedIn === null ? "Pending" : row.IsDeleted ? "Locked" : "Active",
						Value: row.LastLoggedIn === null ? UserStatus.PENDING : row.IsDeleted ? UserStatus.LOCKED : UserStatus.ACTIVE,
						IsSelected: false
					}))
					.uniqBy('Label')
					.value()
			}
			, {
				Id: 2,
				Title: "Role",
				IsSelectedAll: false,
				Options: _(!UserService.hasSysAdminRole() ? Users : organizationUsers).map((row) => {
					return {
						Key: "RoleID",
						Id: row.ID,
						Label: getRoleName(row.RoleID),
						Value: row.RoleID as any,
						IsSelected: false,
					};
				}).uniqBy('Label')
					.value(),
			},
		]
		setFilterOptions(filterData)
	}

	const handleApplyFilters = (filters: CustomFilterCategory[]) => {
		setFilterOptions(filters);
		const { result } = UtilityService.getFilterTypes(filters);
		setSelectedFilterTypes(result)
	};


	useEffect(() => {
		initialFilterOptions()
	}, [rowData]);

	useEffect(() => {
		if (UserService.hasSysAdminRole()) {
			setCheckedUsers([])
			if (selectedOrgIds?.length === 0) {
				setGridLoading(true)
				setShowMultiActionButtons(false)
			}
			else {
				setShowMultiActionButtons(true)
				setCheckedUsers([])
			}
		}
	}, [selectedOrgIds])

	useEffect(() => {
		if (!!gridApi && gridLoading) {
			gridApi?.refreshCells({ force: true })
		}
	}, [gridLoading])


	useEffect(() => {
		setHeaderTitle(pageTitles.USERS);
		setHeaderCount(Users?.length || 0);
		setRefreshHandler(gridRefresh);
		return setHeaderTitle
	}, [gridApi, columnApi])

	const getMenuActions = (data: UserModel) => {

		return [{
			Name: ActionLabels.REINVITE,
			Icon: ReInviteIcon,
			Hide: data.LastLoggedIn !== null,
			OnClick: () => openConfirmDialogReinvite(data.ID, "re-invite"),
		}, {
			Name: data.IsDeleted ? ActionLabels.UNLOCK : ActionLabels.LOCK,
			Icon: LockIcon,
			Hide: (data.RoleID === Role.SYSTEM_ADMIN || data.ID === Profile.ID),
			OnClick: () => openConfirmDialog(data.ID, data.IsDeleted ? "unlock" : "lock")
		},
		{
			Name: ActionLabels.EDIT,
			Icon: EditIcon,
			OnClick: () => openEditUser(data.ID, data),
			Hide: UserService.hasManagerRole() && data.RoleID === Role.ORGANIZATION_ADMIN
		},
		{
			Name: ActionLabels.DELETE,
			Icon: TrashIcon,
			Hide: (data.RoleID === Role.SYSTEM_ADMIN || data.ID === Profile.ID || (UserService.hasManagerRole() && data.RoleID === Role.ORGANIZATION_ADMIN)),
			OnClick: () => openDeleteConfirmDialog(data)
		}]
	}

	const gridRefresh = () => {
		resetFilters()
		if (UserService.hasSysAdminRole() && !!selectedOrgIds) {
			getUsersByOrgId(selectedOrgIds)
		}
		else {
			LoadUsers(dispatch);
		}
		if (!!columnApi) {
			columnApi.resetColumnState()
		}
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}

		gridApi.deselectAll();
		setShowMultiActionButtons(false)
		setCheckedUsers([])
		setSelectedOrgIds(SelectedOrganizations)
	}

	const resetFilters = () => {
		setFilterOptions([])
		setSelectedFilterTypes([])
		initialFilterOptions()
	}

	const closeConfirmDialog = (isConfim: boolean) => {
		if (!!isConfim) {
			setIsLoading(true)
			let User = rowData.find((x: UserModel) => x.ID === clickRowId)
			let Name = User ? User.FirstName + " " + User.LastName : "";
			var isDeleteAction = buttonName === "delete";
			var action = isDeleteAction
				? UserService.deleteUser(clickRowId)
				: UserService.updateUserStatus(clickRowId);
			action.then(() => {
				setShow(false);
				setClickRowId('');
				setButtonName('');
				setMobileMenu(false);
				setIsLoading(false);
				setCheckedUsers([]);
				deselectAll()
				resetFilters()
				isDeleteAction ? setToast(ToasterTexts.USER_DELETE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS) : setToast(User?.IsDeleted ? ToasterTexts.USER_UNLOCK_SUCCESS.replace('<Name>', Name) : ToasterTexts.USER_LOCK_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
				if (UserService.hasSysAdminRole() && !!selectedOrgIds) {
					getUsersByOrgId(selectedOrgIds)
				}
				else {
					LoadUsers(dispatch);
				}
				gridApi.deselectAll();
			}).catch(err => {
				setShow(false);
				setClickRowId('');
				setButtonName('');
				setMobileMenu(false);
				setIsLoading(false);
				setCheckedUsers([]);
				deselectAll()
				setToast(ToasterTexts.IN_ACTIVE_PLAN, ToasterType.DANGER)
				gridApi.deselectAll();
			})
		} else {
			setShow(false);
			setClickRowId('');
			setButtonName('');
			setMobileMenu(false);
			setIsLoading(false);
			setCheckedUsers([]);
			deselectAll()
		}
	};

	const closeConfirmDialogReinvite = (isConfim: boolean) => {
		if (!!isConfim) {
			setIsLoading(true)
			UserService.reinviteUser(clickRowId)
				.then(() => {
					setClickRowId('');
					setButtonName('');
					setMobileMenu(false);
					setIsLoading(false);
					setCheckedUsers([]);
					deselectAll()
					setReinviteOption(false)
					setToast(ToasterTexts.REINVITE_MESSAGE, ToasterType.SUCCESS);
					if (UserService.hasSysAdminRole() && !!selectedOrgIds) {
						getUsersByOrgId(selectedOrgIds)
					}
					else {
						LoadUsers(dispatch);
					}
				}).catch((error: any) => {
					if (error && error.response && error.response.data && error.response.data.code === "USER_NOT_FOUND") {
						setToast(ToasterTexts.USER_NOT_FOUND, ToasterType.DANGER)
					}
					else if (error && error.response && error.response.data && error.response.data.code === "USER_ALREADY_LOGGED_IN") {
						setToast(ToasterTexts.USER_ALREADY_LOGGED_IN, ToasterType.DANGER)
					}
					setClickRowId('');
					setButtonName('');
					setMobileMenu(false);
					setIsLoading(false);
					setCheckedUsers([]);
					deselectAll()
					setReinviteOption(false)
				})

		} else {
			setClickRowId('');
			setButtonName('');
			setMobileMenu(false);
			setIsLoading(false);
			setCheckedUsers([]);
			deselectAll()
			setReinviteOption(false)
		}
	};

	const openConfirmDialog = (rowId: string, action: string) => {
		let row = rowData.filter((x) => x.ID === rowId)[0];
		let text = !row.IsDeleted
			? appNote.LOCK_USER
			: appNote.UNLOCK_USER;
		if (action === "delete") text = appNote.DELETE_USER;
		setClickRowId(rowId);
		setButtonName(action);
		setMobileMenu(false);
		setIsLoading(false);
		setShow(true);
		setText(text)
	}

	const openConfirmDialogReinvite = (rowId: string, action: string) => {
		setClickRowId(rowId);
		setMobileMenu(false);
		setIsLoading(false);
		setReinviteOption(true)
	}

	const closeEditUser = (isConfim: boolean) => {
		resetFilters()
		setClickRowId('');
		setMobileMenu(false);
		setUserToEdit(undefined)
		setEditOption(false)
		if (!!isConfim)
			if (UserService.hasOrgAdminRole() || UserService.hasManagerRole()) {
				LoadUsers(dispatch);
			}
			else {
				getUsersByOrgId(selectedOrgIds);
			}
	};

	const openEditUser = (rowId: string, User?: UserModel) => {
		setClickRowId(rowId);
		setMobileMenu(false);
		setUserToEdit(User)
		setEditOption(true)
	}

	const getOrgName = (row: string) => {
		var data = Organizations.find((x) => x.ID === row)?.Name;
		return data;
	}

	const getRoleName = (row: number) => {
		let data = Roles.find(x => x.ID === row)?.Name
		return data;
	}

	const handleRowClick = (row: UserModel) => {
		if (IsMobileDevice) {
			setMobileMenu(true);
			setClickRowData(row)
		}
	}

	const CloseMobileMenu = () => {
		setMobileMenu(false);
		// setClickRowData(null)
	}

	const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => { UserService.hasSysAdminRole() && !!selectedOrgIds ? getUsersByOrgId(selectedOrgIds) : LoadUsers(dispatch) })

	const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (IsMobileDevice) {
			setShowFilters(true)
		}
		else {
			setAnchorEl(event.currentTarget)
		}
	}

	const handleCloseFilter = () => {
		setAnchorEl(null)
		setShowFilterOptions(false)
		setShowFilters(false)
	}

	const openMassActionConfirmDialog = (action: string) => {

		if (action === UsersMassAction.DELETE && CheckedUsers?.length === 1) {
			openDeleteConfirmDialog(CheckedUsers[0])
			return
		}
		let text = action === UsersMassAction.DELETE ? appNote.MASS_ACTION_TEXT.replace('<action>', UsersMassAction.DELETE).replace('<name>', CheckedUsers.length > 1 ? pageTitles.USERS.toLocaleLowerCase() : UsersMassAction.USER) : action === UsersMassAction.LOCK ? appNote.MASS_ACTION_TEXT.replace('<action>', UsersMassAction.LOCK).replace('<name>', CheckedUsers.length > 1 ? pageTitles.USERS.toLocaleLowerCase() : UsersMassAction.USER) : appNote.MASS_ACTION_TEXT.replace('<action>', UsersMassAction.UNLOCK).replace('<name>', CheckedUsers.length > 1 ? pageTitles.USERS.toLocaleLowerCase() : UsersMassAction.USER)
		setOpenMassAction(true)
		setText(text)
		setButtonName(action)
		setMobileMenu(false)
		setIsLoading(false)
	}

	const closeMassActionConfirmDialog = (isConfim: boolean) => {
		if (!!isConfim) {
			setIsLoading(true)
			const data = CheckedUsers.map((item) => {
				return item.ID
			})
			UserService.usersMassAction(buttonName, data).then((res) => {
				if (UserService.hasSysAdminRole() && !!selectedOrgIds) {
					getUsersByOrgId(selectedOrgIds)
				}
				else {
					LoadUsers(dispatch);
				}
				buttonName === UsersMassAction.DELETE ? setToast(ToasterTexts.MULTIPLE_USER_DELETE_SUCCESS, ToasterType.SUCCESS) : buttonName === UsersMassAction.UNLOCK ? setToast(ToasterTexts.MULTIPLE_USER_UNLOCK_SUCCESS, ToasterType.SUCCESS) : setToast(ToasterTexts.MULTIPLE_USER_LOCK_SUCCESS, ToasterType.SUCCESS)
				setOpenMassAction(false)
				setButtonName('')
				setMobileMenu(false)
				setIsLoading(false)
				setCheckedUsers([])
				deselectAll()
				setShowMultiActionButtons(false)
			}).catch(err => {
				if (err.response.status === 404 || err.response.status === 400 || err.response.status === 500) {
					setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
					setIsLoading(false)
					setCheckedUsers([])
					deselectAll()
					setShowMultiActionButtons(false)
				}
			})
		} else {
			setOpenMassAction(false)
			setButtonName('')
			setMobileMenu(false)
			setIsLoading(false)
		}
	};

	const onGridReady = (params) => {
		setGridApi(params.api);
		setColumnApi(params.columnApi)
		// params.columnApi.applyColumnState({ state: [{ colId: "CreatedDateTime", sort: 'desc' }] })
	}

	const onSelectionChanged = () => {
		let SelectedUsers: UserModel[] = gridApi.getSelectedRows()
		if (gridApi && SelectedUsers.length > 0) {
			setSelectedCount(SelectedUsers.length)
			setShowMultiActionButtons(true)
			setCheckedUsers(SelectedUsers)
		}
		else {
			setSelectedCount(SelectedUsers.length)
			setShowMultiActionButtons(false)
			setCheckedUsers([])
		}
	}

	const getGridTitle = () => {
		if (ShowMultiActionButtons) {
			if (CheckedUsers && CheckedUsers.length > 1) {
				return CheckedUsers.length + " Items selected";
			}
			else if (CheckedUsers && CheckedUsers.length === 1) {
				return "1 Item selected";
			}
			else {
				return rowData.length + " " + pageTitles.USERS
			}
		}
		else {
			if (rowData.length === 1) {
				return "1 User"
			}
			else {
				return rowData.length + " " + pageTitles.USERS
			}
		}
	}

	const clearSelection = () => {
		if (!!gridApi && !!CheckedUsers.length)
			gridApi.deselectAll();

		if (!!rowData.length || !!selectedOrgIds.length) {
			setShowMultiActionButtons(false)
			setSelectedOrgIds([])
			if (UserService.hasSysAdminRole()) {
				setRowData([])
				setHeaderCount(0)
			}
			dispatch(updateUsersSelectedOrgIDs([]));
			dispatch(updateOrganizationsUsers([]));
		}

	}

	const deselectAll = () => {
		if (!!gridApi && !!CheckedUsers.length) {
			gridApi.deselectAll();
			setHeaderCount(0)
		}
	}

	const handleCellRowClick = (e: any, row: UserModel) => {
		if (!IsMobileDevice && e.colDef.field !== "Action") {
			openEditUser(row.ID, row)
		}
	}

	const downloadgriddataExcelFormat = () => {
		// gridApi.exportDataAsCsv()
		const data = rowData.map(x => {
			const status = x.LastLoggedIn === null ? "Pending" : x.IsDeleted ? "Locked" : "Active"
			return {
				...x,
				IsDeleted: status,
				RoleID: getRoleName(x.RoleID),
				CreatedDateTime: UtilityService.convertDateToDay(x.CreatedDateTime).toString(),
				OrganizationID: getOrgName(x.OrganizationID),
				SecondaryPhoneNumbers: x?.SecondaryPhoneNumbers ? x.SecondaryPhoneNumbers?.map(y => y.phoneNumber).join(", ") : ""
			}
		})

		const ExportReportHeaders = [
			{ label: "First Name", value: "FirstName" },
			{ label: "Last Name", value: "LastName" },
			{ label: "Phone Number", value: "PhoneNumber" },
			{ label: "Organization", value: "OrganizationID" },
			{ label: "Email", value: "Email" },
			{ label: "Status", value: "IsDeleted" },
			{ label: "Secondary Phone Numbers", value: "SecondaryPhoneNumbers" },
			{ label: "Updated Date", value: "CreatedDateTime" },
		]

		exportToExcel(ExportReportHeaders, data, `FalkonSMS-Users-${moment(UtilityService.getPreferredTimeZoneTimeNow(), ["MM-DD-YYYY"]
		).format("MM-DD-YYYY")}`, ToasterTexts.EXCEL_EXPORT_USERS_MESSAGE)
	};

	const openMassActionReInviteConfirmDialog = () => {
		let text = appNote.MASS_ACTION_TEXT.replace('<action>', UsersMassAction.REINVITE).replace('<name>', CheckedUsers.length > 1 ? pageTitles.USERS.toLocaleLowerCase() : UsersMassAction.USER)
		setShowMassReInviteConfirmDialog(true)
		setText(text)
		setButtonName(UsersMassAction.REINVITE)
		setMobileMenu(false)
		setIsLoading(false)
	}

	const closeMassActionReInviteConfirmDialog = (isConfim: boolean) => {
		if (!!isConfim) {
			setIsLoading(true)
			const data = CheckedUsers.map((item) => {
				return item.ID
			})
			UserService.usersMassActionReInvite(data).then((res) => {
				if (res.data?.invitedUserIds?.length === data?.length) {
					setToast("Mail has been sent to the users successfully!", ToasterType.SUCCESS)
				}
				if (res?.data?.notFoundUserIds?.length) {
					const notFoundUsers = CheckedUsers.filter(x => res?.data?.notFoundUserIds.includs(x.ID))
					setToast(`${notFoundUsers.map(x => x.FirstName).join(", ")} not found`, ToasterType.DANGER);
				}
				setShowMassReInviteConfirmDialog(false)
				setButtonName('')
				setMobileMenu(false)
				setIsLoading(false)
				setCheckedUsers([])
				deselectAll()
				setShowMultiActionButtons(false)
			}).catch(err => {
				if (err.response?.data?.message === "UserIds are required") {
					setToast("Please select at least one user to send the invite.", ToasterType.DANGER);
				} else {
					setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
				}
				setIsLoading(false)
				setCheckedUsers([])
				deselectAll()
				setShowMultiActionButtons(false)
				setShowMassReInviteConfirmDialog(false)
			})
		} else {
			setShowMassReInviteConfirmDialog(false)
			setButtonName('')
			setMobileMenu(false)
			setIsLoading(false)
		}
	};

	const handleColumnResized = (params: any) => {
		if (IsMobileDevice && params.finished) {
			params.api.refreshCells({
				columns: ['FirstName'],
				force: true,
			});
		}
	}

	const openDeleteConfirmDialog = (data: UserModel) => {
		setClickRowData(data)
		setClickRowId(data?.ID)
		setShowDeleteConfirmDialog(true)
	}

	const closeDeleteConfirmDialog = (isConfirm: boolean) => {
		if (isConfirm) {
			setIsLoading(true)
			UserService.deleteUser(clickRowId, isclearPhoneNumberData).then((res) => {
				let User = rowData.find((x: UserModel) => x.ID === clickRowId)
				setToast(ToasterTexts.USER_DELETE_SUCCESS.replace('<Name>', User.FirstName), ToasterType.SUCCESS)
				setClickRowData(undefined)
				setClickRowId("")
				setShowDeleteConfirmDialog(false)
				setIsClearPhoneNumberData(false)
				setIsLoading(false)
				if (UserService.hasSysAdminRole() && !!selectedOrgIds) {
					getUsersByOrgId(selectedOrgIds)
				}
				else {
					LoadUsers(dispatch);
				}
				gridApi.deselectAll();
			}).catch((err) => {
				setClickRowData(undefined)
				setClickRowId("")
				setShowDeleteConfirmDialog(false)
				setIsClearPhoneNumberData(false)
				setIsLoading(false)
			})

		} else {
			setClickRowData(undefined)
			setClickRowId("")
			setShowDeleteConfirmDialog(false)
			setIsClearPhoneNumberData(false)
		}
	}

	return (
		<>
			<PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
				<div className="d-flex flex-direction h-p-100 o-hidden justify-between">
					{editoption && IsMobileDevice ?
						<UserView
							isSysAdmin={UserService.hasSysAdminRole()}
							onClose={closeEditUser}
							show={editoption}
							User={userToEdit}
							clearSelection={clearSelection}
						/>
						: ShowFilters && IsMobileDevice ?
							<FilterComponent
								Filters={filterOptions}
								HandleApplyFilters={handleApplyFilters}
								OnClose={handleCloseFilter}
							/>
							:
							<>
								<PageHeaderComponent
									GridTitle={""}
									Count={rowData.length}
									Actions={UserService.hasSysAdminRole() ? [{
										OnClick: () => openEditUser("", undefined),
										ButtonLabel: buttonLabels.ADD_USER,
										Icon: IsMobileDevice ? '' : AddUserIcon,
										Variant: "primary-btn",
									},
									{
										OnClick: () => { downloadgriddataExcelFormat() },
										ButtonLabel: "",
										Icon: DownloadedIcon,
										Variant: "secondary-btn"
									}] : [{
										OnClick: () => openEditUser("", undefined),
										ButtonLabel: buttonLabels.ADD_USER,
										Icon: IsMobileDevice ? '' : AddUserIcon,
										Variant: "primary-btn",

									}]
									}
									HandleFilter={(e) => handleClickFilter(e)}
									ShowFilterIcon={true}
									IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
									searchValue={searchValue}
									onSearch={(e) => searchUsers(e)}
									PlaceHolder={"Search a user..."}
									ShowMultiActionButtons={ShowMultiActionButtons}
									MultiActionButtons={[
										{
											Name: buttonLabels.APPLY,
											Variant: "primary",
											ClassName: "mr-1",
											Hide: !UserService.hasSysAdminRole(),
											OnClick: () => { getUsersByOrgId(selectedOrgIds) }
										},
										{
											Name: ActionLabels.DELETE,
											Variant: "primary",
											ClassName: "mr-1",
											Icon: MultiSelectDeleteIcon,
											Hide: !!CheckedUsers.length ? (!!CheckedUsers.length && CheckedUsers.findIndex(x => x.ID === Profile.ID) !== -1) : true,
											OnClick: () => openMassActionConfirmDialog(UsersMassAction.DELETE)
										},
										{
											Name: (!!CheckedUsers.length && CheckedUsers.every(item => item.IsDeleted)) ? ActionLabels.UNLOCK : ActionLabels.LOCK,
											Variant: "primary",
											ClassName: "mr-1",
											Icon: (!!CheckedUsers.length && CheckedUsers.every(item => item.IsDeleted)) ? MultiSelectUnlockIcon : MultiSelectLockIcon,
											Hide: !((!!CheckedUsers.length && CheckedUsers.every(item => item.IsDeleted)) || (!!CheckedUsers.length && CheckedUsers.findIndex(x => x.ID === Profile.ID) === -1 && CheckedUsers.every(item => !item.IsDeleted) && CheckedUsers.every(item => item.LastLoggedIn !== null))),
											OnClick: () => openMassActionConfirmDialog((!!CheckedUsers.length && CheckedUsers.every(item => item.IsDeleted)) ? UsersMassAction.UNLOCK : UsersMassAction.LOCK)
										},
										{
											Name: ActionLabels.REINVITE,
											Variant: "primary",
											ClassName: "mr-1",
											Icon: ReInviteIcon,
											Hide: !(!!CheckedUsers.length && CheckedUsers.every(item => item.LastLoggedIn === null)),
											OnClick: () => openMassActionReInviteConfirmDialog()
										},
										{
											Name: ActionLabels.CLEAR_SELECTION,
											Variant: "text",
											ClassName: "p-0 mr-1 w-space",
											Icon: MultiSelectCrossIcon,
											Hide: false,
											OnClick: () => clearSelection()
										}
									]}
									showAutoComplete={UserService.hasSysAdminRole()}
									autoCompleteOptions={Organizations.filter(x => (x.Name !== null && !x.IsDeleted))}
									onChangeAutoComplete={(ids) => {
										setSelectedOrgIds(ids);
									}}
									autoCompleteValue={selectedOrgIds}
								/>
								<GridComponent
									ColumnDefs={UsersColoumnDefs}
									RowData={rowData}
									OnGridReady={onGridReady}
									OnSelectionChanged={onSelectionChanged}
									OnGridRowClick={handleRowClick}
									IsPaginationEnabled={!IsMobileDevice}
									EmptyLabel={emptyLabels.USERS}
									LockVisible={IsMobileDevice}
									filterOptions={filterOptions}
									IsFilterPresent={true}
									gridApi={gridApi}
									OnGridCellRowClick={handleCellRowClick}
									ShowRowPointer={true}
									onColumnResized={handleColumnResized}
								/>
							</>}
					{editoption && !IsMobileDevice &&
						<UserView
							isSysAdmin={UserService.hasSysAdminRole()}
							onClose={closeEditUser}
							show={editoption}
							User={userToEdit}
							clearSelection={clearSelection}
						/>
					}

					{
						show && <ConfirmDialog
							ButtonName={buttonName}
							onClose={closeConfirmDialog}
							Show={show}
							Text={text}
							Loading={IsLoading}
							IsMobileDevice={IsMobileDevice}
						/>
					}

					{
						reinviteOption && <ConfirmDialog
							ButtonName={ActionLabels.REINVITE}
							onClose={closeConfirmDialogReinvite}
							Show={reinviteOption}
							Text={appNote.RE_INVITE_USER}
							Loading={IsLoading}
							IsMobileDevice={IsMobileDevice}
						/>
					}

					{openMassAction &&
						<ConfirmDialog
							ButtonName={buttonName}
							onClose={closeMassActionConfirmDialog}
							Show={openMassAction}
							Text={text}
							Loading={IsLoading}
							IsMobileDevice={IsMobileDevice}
						/>}

					{showMassReInviteConfirmDialog &&
						<ConfirmDialog
							ButtonName={buttonName}
							onClose={closeMassActionReInviteConfirmDialog}
							Show={showMassReInviteConfirmDialog}
							Text={text}
							Loading={IsLoading}
							IsMobileDevice={IsMobileDevice}
						/>}

					{!IsMobileDevice && Boolean(anchorEl) &&
						<Popover
							open={Boolean(anchorEl)}
							anchorEl={anchorEl}
							onClose={handleCloseFilter}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							classes={{ paper: `min-w-50 ${ShowFilterOptions ? "min-h-55" : ""}` }}
						// BackdropProps={{
						// 	invisible: true,
						// 	onClick: (event) => event.stopPropagation(),
						// }}
						>
							<FilterComponent
								Filters={filterOptions}
								HandleApplyFilters={handleApplyFilters}
								OnClose={handleCloseFilter}
							/>
						</Popover>
					}

					{
						IsMobileDevice && MobileMenu && ClickRowData !== null &&
						<Dialog
							fullWidth
							onClose={CloseMobileMenu}
							aria-labelledby="responsive-dialog-title"
							open={MobileMenu}
							classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
						>
							<DialogTitle className="dialog-header pb-1">
								<div className="h1 color-display-title d-flex" id="customized-dialog-title">
									{UtilityService.trimMessage(ClickRowData?.FirstName, 12) + " " + UtilityService.trimMessage(ClickRowData?.LastName, 12)}
									<Tooltip title='Close' placement='bottom'>
										<span className="ml-auto">
											<CancelIcon onClick={(e: any) => { e.stopPropagation(); CloseMobileMenu() }} />
										</span>
									</Tooltip>
								</div>
							</DialogTitle>
							<DialogContent className={"mln-1 o-hidden pt-0"}>
								<MenuItemRenderer MenuData={getMenuActions(ClickRowData)} OnClick={CloseMobileMenu} />
							</DialogContent>
						</Dialog>
					}

					{
						showDeleteConfirmDialog &&
						<Dialog
							onClose={() => closeDeleteConfirmDialog(false)}
							open={showDeleteConfirmDialog}
							classes={{ paper: `br-2 dialogue-shadow ${IsMobileDevice ? "w-p-100" : "w-p-45"}` }}
							BackdropProps={IsMobileDevice ? {} : { style: { backgroundColor: "transparent" } }}
						>
							<DialogTitle className={` pb-1 ${IsDarkMode ? "bg-color-sidebar-bg" : ""}`} >
								<div className="h1 color-display-title d-flex">
									{"Confirm"}
									<Tooltip title='Close' placement='bottom'>
										<span className="ml-auto">
											<CancelIcon onClick={(e: any) => { e.stopPropagation(); closeDeleteConfirmDialog(false) }} />
										</span>
									</Tooltip>
								</div>
							</DialogTitle>
							<DialogContent className={`${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"} pb-0`}>
								<div className={`h4-regular color-menu-list-font-color ${IsMobileDevice ? "" : "mb-1"}`}>Are you sure you want to delete <span className="h3-medium color-primary-accent">{ClickRowData?.FirstName}</span>?</div>
								{(PhoneNumbers.find(x => x.ID === ClickRowData?.PhoneNumberID)?.Users < 2 && Settings?.Settings?.find((x) => x.Code === SettingsService.Clear_phonenumber_data)?.Value === "true") &&
									<div className="border-primary-divider bg-color-report-background br-2 p-2">
										<div className="color-primary-accent d-flex align-start pb-1 bb-primary-divider-1">
											<Checkbox
												classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
												className="mr-2 p-0"
												onChange={(e) => setIsClearPhoneNumberData(e?.target?.checked)}
												value={isclearPhoneNumberData}
											/>
											<div>
												<div className="h4-medium">Also delete their data</div>
												<div className="h5-regular color-text-field-label">Documents & templates, recipients & contacts, and release {getPhoneNumber(ClickRowData?.PhoneNumberID)} back to the pool.</div>
											</div>
										</div>
										<div className="h5-regular color-text-field-label mt-1">Leave unchecked to remove the login only — their documents, contacts and phone number stay with the organization.</div>
									</div>
								}
							</DialogContent>
							<DialogActions className={`pb-2 ${IsDarkMode ? "bg-color-sidebar-bg" : ""} mr-2`}>
								<ButtonComponent ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn"} OnClick={() => closeDeleteConfirmDialog(false)} />
								<ButtonComponent ButtonLabel={buttonLabels.DELETE} Variant={"primary-btn"} OnClick={() => closeDeleteConfirmDialog(true)} Loading={IsLoading} />
							</DialogActions>
						</Dialog>
					}
				</div>
			</PullToRefresh >
		</>

	);
}

export default UserComponent;